import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrderNotificationService {
  private newOrderCount = new BehaviorSubject<number>(0);

  constructor() {
    // Load saved count from localStorage
    const savedCount = localStorage.getItem('newOrderCount');
    if (savedCount) {
      this.newOrderCount.next(parseInt(savedCount, 10));
    }
  }

  incrementCount() {
    const currentCount = this.newOrderCount.value + 1;
    this.newOrderCount.next(currentCount);
    localStorage.setItem('newOrderCount', currentCount.toString());
  }

  resetCount() {
    this.newOrderCount.next(0);
    localStorage.setItem('newOrderCount', '0');
  }

  getCount() {
    return this.newOrderCount.asObservable();
  }
} 